const loadJQueryPlugins = ($) => {
    $.fn.removeValidationTooltip = function (config) {
        // to remove tooltip just pass tooltip css class name
        if (!(config && config.toolTipCss)) {
            return;
        }
        $(this).find(`span.${config.toolTipCss}_text`).remove();
        $(this).removeClass(config.toolTipCss);
        return this;
    };
    $.fn.showValidationTooltip = function (config) {
        // to show tooltip just pass tooltip text and css class name
        if (!(config && config.toolTipText)) {
            return;
        }
        if (config.isPreChatText) {
            $(this)
                .closest('.apexchat_question_type_single_col')
                .find('.apexchat_error_msg')
                .remove(); // removing the previous summary.
            $(this).closest('.apexchat_rd_prechat_input').addClass(config.toolTipCss);
            // appending new sumamry.
            $(this)
                .closest('.apexchat_question_type_single_col')
                .append(
                    `<div class="apexchat_error_msg" title="${config.toolTipText}" tabindex="0">${config.toolTipText}</div>`
                );
        } else {
            $(this).find(`span.${config.toolTipCss}_text`).remove();
            $(this).addClass(config.toolTipCss);
            $(this).append(
                `<span class="${config.toolTipCss}_text" title="${config.toolTipText}" tabindex="0">${config.toolTipText}</span>`
            );
        }
        return this;
    };
    $.fn.preventTyping = function () {
        // prevent user to type anything.
        // as for mobile browser, only keyup event works for on screen keyboard so we used keyup event to prevent typing
        $(this).keyup(function (e) {
            $(this).val('');
        });
        return this;
    };
    $.fn.allowTyping = function () {
        // allow user to type anything.
        // reverting its functionality to normal keyup
        $(this).unbind('keyup').keyup();
        return this;
    };
    $.fn.disable = function (options) {
        const settings = $.extend(
            {
                // These are the defaults.
                recursively: false,
                applyGrayBackground: false
            },
            options
        );
        if (settings.applyGrayBackground) {
            $(this).addClass('apexchat_disabled_element');
        }
        $(this).prop('disabled', true).css('pointer-events', 'none');
        if (settings.recursively) {
            $(this)
                .children()
                .each(function (index) {
                    $(this).disable(settings.recursively);
                });
        }
        return this; // to allow method chaining
    };
    $.fn.populateSelectList = function (
        options /* [{ value:'option value', text:'option text' },...] */
    ) {
        const $dropdown = this;
        $.each(options, function () {
            const optionElement = $('<option />').val(this.value).text(this.text);
            if (this.selected) {
                optionElement.attr('selected', 'selected');
            }
            $dropdown.append(optionElement);
        });
    };
    ($.fn.isDisabled = function () {
        return $(this).is(':disabled') || $(this).css('pointer-events') == 'none';
    }),
        $.fn.enable = (recursively) => {
            $(this).prop('disabled', false).css('pointer-events', 'auto');
            $(this).removeClass('apexchat_disabled_element');
            if (recursively) {
                $(this)
                    .children()
                    .each(function (index) {
                        $(this).enable(recursively);
                    });
            }
            return this; // to allow method chaining
        };
};
export default loadJQueryPlugins;
